import React, { Component } from "react";
import { Theme, createStyles, withStyles } from "@material-ui/core/styles";
import { WithStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import clsx from "clsx";
import { v4 as uuidv4 } from "uuid";
import { UIPageTitle } from "./UIPageTitle";
import { UIStyleProps } from "./UIComponents";
import PlatformUtils from "../../utils/platform";

const modalStyles = function (theme: Theme) {
	return createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			boxShadow: theme.shadows[3],
			padding: theme.spacing(4, 3, 3),
		},
	});
};

interface UIModalProps extends WithStyles {
	open: boolean;
	title: string | React.ReactNode;
	regTitle?: boolean;
	titleClassName?: string;
	pageTitle?: string;
	onClose: () => any;
	children?: React.ReactNode;
	showCloseIcon?: boolean;
	noPadding?: boolean;
	hideTransition?: boolean;
	disableRestoreFocus?: boolean;
	noContainer?: boolean;
	contentClassName?: string;
}

export class AppModal extends Component<UIModalProps & UIStyleProps> {
	render() {
		const { classes } = this.props;
		const id = uuidv4();
		const showTransition: boolean = !this.props.hideTransition;

		const modalContent = (
			<div
				className={clsx(
					classes.paper,
					!this.props.noContainer && "container",
					this.props.className,
					PlatformUtils.IOS_USER && "bw-ios-overrides"
				)}
				style={this.props.style}
			>
				<div className="d-flex justify-content-between align-items-start" style={{ wordBreak: "break-word" }}>
					{this.props.title && (
						<>
							{this.props.regTitle && (
								<h6
									className={clsx(this.props.titleClassName || "mb-0 pb-0")}
									id={"ui-modal-title" + id}
								>
									{this.props.title}
								</h6>
							)}
							{!this.props.regTitle && (
								<h3
									className={clsx(this.props.titleClassName || "mb-0 pb-0")}
									id={"ui-modal-title" + id}
								>
									{this.props.title}
								</h3>
							)}
						</>
					)}
					{this.props.showCloseIcon && (
						<IconButton
							edge="start"
							aria-label="Close"
							className="ui-modal-close-icon"
							style={{ marginTop: "-15px", marginRight: "-15px" }}
							onClick={(e) => {
								e.preventDefault();
								this.props.onClose();
							}}
						>
							<CloseIcon />
						</IconButton>
					)}
				</div>
				<div
					className={clsx(!this.props.noPadding && "p-1", this.props.contentClassName || "ui-modal-content")}
					id={"ui-modal-description" + id}
				>
					{this.props.children}
				</div>
			</div>
		);

		return (
			<>
				{this.props.pageTitle && this.props.open && <UIPageTitle pageTitle={this.props.pageTitle} />}
				<Modal
					aria-labelledby={"ui-modal-title" + id}
					aria-describedby={"ui-modal-description" + id}
					className={clsx(
						classes.modal,
						PlatformUtils.MAC_USER && "corre-mac-overrides",
						this.props.className
					)}
					open={this.props.open}
					onClose={() => this.props.onClose()}
					closeAfterTransition={showTransition}
					disableRestoreFocus={this.props.disableRestoreFocus}
					BackdropComponent={showTransition ? Backdrop : undefined}
					BackdropProps={
						showTransition
							? {
									timeout: 500,
							  }
							: {}
					}
				>
					{showTransition ? <Fade in={this.props.open}>{modalContent}</Fade> : <> {modalContent}</>}
				</Modal>
			</>
		);
	}
}

const UIModal = withStyles(modalStyles)(AppModal);
export default UIModal;
